import api from '@/js/services/api';

export default {

    deleteFile(fileId) {
        return api().post(`/files/${fileId}/delete`);
    },

    uploadFile(userId, formData) {
        return api().post(`/files/user/${userId}/upload`, formData)
    }
}
